// Should the MCP switch refuse a click right now?
//
// Two separate reasons, and they are easy to conflate:
//
// `saving` — one of the three controls in the Add-ons dialog is mid-write. All
// three write the same `ai` block, and closing the AI gate withdraws the MCP
// opt-in as a side effect, so they have to take turns. Without that, an operator
// can start enabling MCP, close the last AI grant before it lands, and have the
// older response merge a stale `mcpEnabled: true` over the newer `false` — the
// dialog then shows a switch the database disagrees with, which is the whole
// class of bug this surface keeps producing.
//
// The gate — MCP cannot be turned ON while AI is unreachable, because the flag
// would sit latent and open MCP by itself when AI came back. Turning it OFF is
// always allowed, or a workspace that lost AI access while MCP was on could
// never close it. That asymmetry is the `!mcpEnabled` term.
export const isMcpSwitchLocked = ({ saving, aiGateOpen, mcpEnabled }) =>
  Boolean(saving) || (!aiGateOpen && !mcpEnabled);
